<div class="pt-3" *ngIf="notFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!notFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <form (submit)="onSubmit()" class="m-4" *ngIf="!loadingMembership">
      <div class="alert alert-info">
        Rolling event types are billed using an individual recurring membership specific to the event type. This membership is configured using the settings below.
      </div>

      <h3 class="mt-2" id="setup">Setup</h3>

      <div class="form-group">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label for="intervalSelect">Membership Length</label>
            <div [ngbTooltip]="(eventType?.status !== EventTypeStatus.draft) ? 'May not be changed for an existing non-draft event type.' : null">
              <select id="intervalSelect" name="interval"
                      class="custom-select"
                      [(ngModel)]="membership.interval"
                      (ngModelChange)="unsavedChanges = true"
                      [disabled]="eventType?.status !== EventTypeStatus.draft">
                <option [ngValue]="MembershipInterval.weekly">Weekly</option>
                <option [ngValue]="MembershipInterval.biweekly">Biweekly</option>
                <option [ngValue]="MembershipInterval.fourWeeks">Four Weeks</option>
                <option [ngValue]="MembershipInterval.monthly">Monthly</option>
                <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
                <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
                <option [ngValue]="MembershipInterval.yearly">Annual</option>
              </select>
            </div>
          </div>
        </div>
        <small class="form-text text-muted">
         This is the time between payments.
        </small>
        <div class="form-text text-danger">{{ errors.interval }}</div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label for="allowChooseStartDateSelect">Allow customers to choose start date?</label>
            <select id="allowChooseStartDateSelect" name="allow_selecting_start_date"
                    class="custom-select"
                    [(ngModel)]="membership.allow_selecting_start_date"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="false">No</option>
              <option [ngValue]="true">Yes</option>
            </select>
          </div>
        </div>
        <small class="form-text text-muted">
          If a customer cannot select a start date, their membership will start as soon as they complete its purchase.
        </small>
        <div class="form-text text-danger">{{ errors.allow_selecting_start_date }}</div>
      </div>

      <div class="form-group"
           *ngIf="!isSubMonthlyMembershipInterval(membership.interval)">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label for="billDayOfMonthInput">Billing day of month (optional)</label>
            <input id="billDayOfMonthInput" type="number" name="bill_day_of_month"
                   min="1" max="31"
                   class="form-control"
                   [(ngModel)]="membership.bill_day_of_month"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <small class="form-text text-muted">
          If this field is provided, then memberships of this type will always bill on the given day of month. If the membership does not start on the given day, the first billing period will be prorated. If a given month has fewer days than the provided number, the bill will occur on the last day of that month instead.
          <br>
          If this is left blank, then memberships will bill on the day of month on which they originally started.
        </small>
        <div class="form-text text-danger">{{ errors.bill_day_of_month }}</div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label for="hasIcon">Does this membership have an associated icon?</label>
            <select id="hasIcon"
                    name="hasIcon"
                    class="custom-select"
                    [(ngModel)]="hasIcon"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
        </div>
        <small class="form-text text-muted">
          The icon will be displayed when a customer with an active membership checks in.
        </small>
      </div>

      <div *ngIf="hasIcon" class="indented-subsection">

        <div class="form-group row">
          <div class="col-lg-6 col-md-8 col-12">
            <div class="form-group">
              <label for="iconColorHexSelect">Icon Color</label>
              <app-color-picker [id]="'iconColorHexSelect'"
                                [(content)]="membership.icon_color_hex"></app-color-picker>
              <small class="form-text">
                The icon will be displayed when a customer with an active membership checks in.
              </small>
              <div class="form-text text-danger">{{ errors.icon_color_hex }}</div>
            </div>
            <div class="form-group">
              <label for="iconInitialsInput">Icon Initials</label>
              <input id="iconInitialsInput" type="text" class="form-control" name="icon_initials"
                     required maxlength="2"
                     [(ngModel)]="membership.icon_initials"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text">2 characters max</small>
              <div class="form-text text-danger">{{ errors.icon_initials }}</div>
            </div>
          </div>
          <div class="col-lg-6 col-md-4 col-12" *ngIf="membership.icon_color_hex !== ''">
            <div class="d-inline-block rounded-border p-3">
              <label>Icon Preview</label>
              <br>
              <app-membership-icon [size]="2"
                                   [colorHex]="membership.icon_color_hex"
                                   [iconInitials]="membership.icon_initials"></app-membership-icon>
            </div>
          </div>
        </div>

      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label for="youthProgrammingSelect">Is this membership used for youth programming?</label>
            <select id="youthProgrammingSelect" name="is_youth_programming"
                    class="custom-select"
                    [(ngModel)]="membership.is_youth_programming"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="false">No</option>
              <option [ngValue]="true">Yes</option>
            </select>
          </div>
        </div>
        <small class="form-text text-muted">
          Youth programming memberships function identically to regular memberships, but may be filtered separately in revenue reports and the customer list.
        </small>
        <div class="form-text text-danger">{{ errors.is_youth_programming }}</div>
      </div>

      <h3 class="mt-2" id="benefits">Benefits</h3>

      <div class="form-group">
        <label for="num_new_customer_guest_passes">Number of "new customers only" guest passes</label>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-5">
            <input type="number"
                   id="num_new_customer_guest_passes"
                   name="num_new_customer_guest_passes"
                   min="0" max="100" step="1"
                   class="form-control"
                   [(ngModel)]="membership.num_new_customer_guest_passes"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <small class="form-text text-muted">
          {{ orgConfig.getGuestPassEligibilityDescription(GuestPassEligibility.newCustomersOnly) }}
        </small>
        <div class="form-text text-danger">{{ errors.num_new_customer_guest_passes }}</div>
      </div>

      <div class="form-group row" *ngIf="membership.num_new_customer_guest_passes > 0">
        <div class="col-lg-6 col-md-8">
          <div class="indented-subsection">
            <label for="new_customer_guest_pass_frequency">"New customers only" guest pass frequency</label>
            <select id="new_customer_guest_pass_frequency" name="new_customer_guest_pass_frequency"
                    class="custom-select"
                    [(ngModel)]="membership.new_customer_guest_pass_frequency"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="MembershipInterval.daily">Daily</option>
              <option [ngValue]="MembershipInterval.weekly">Weekly</option>
              <option [ngValue]="MembershipInterval.monthly">Monthly</option>
              <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
              <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
              <option [ngValue]="MembershipInterval.yearly">Yearly</option>
            </select>
            <small class="form-text text-muted">
              Guest passes are granted each calendar month/quarter/year and must be used within that month/quarter/year.
            </small>
            <div class="form-text text-danger">{{ errors.new_customer_guest_pass_frequency }}</div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="num_lapsed_customer_guest_passes">Number of "lapsed customers only" guest passes</label>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-5">
            <input type="number"
                   id="num_lapsed_customer_guest_passes"
                   name="num_lapsed_customer_guest_passes"
                   min="0" max="100" step="1"
                   class="form-control"
                   [(ngModel)]="membership.num_lapsed_customer_guest_passes"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <small class="form-text text-muted">
          {{ orgConfig.getGuestPassEligibilityDescription(GuestPassEligibility.lapsedCustomersOnly) }}
          The window is configured under <a routerLink="/organization-settings" target="_blank">Organization Settings</a>.
        </small>
        <div class="form-text text-danger">{{ errors.num_lapsed_customer_guest_passes }}</div>
      </div>

      <div class="form-group row" *ngIf="membership.num_lapsed_customer_guest_passes > 0">
        <div class="col-lg-6 col-md-8">
          <div class="indented-subsection">
            <label for="lapsed_customer_guest_pass_frequency">"Lapsed customers only" guest pass frequency</label>
            <select id="lapsed_customer_guest_pass_frequency" name="lapsed_customer_guest_pass_frequency"
                    class="custom-select"
                    [(ngModel)]="membership.lapsed_customer_guest_pass_frequency"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="MembershipInterval.daily">Daily</option>
              <option [ngValue]="MembershipInterval.weekly">Weekly</option>
              <option [ngValue]="MembershipInterval.monthly">Monthly</option>
              <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
              <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
              <option [ngValue]="MembershipInterval.yearly">Yearly</option>
            </select>
            <small class="form-text text-muted">
              Guest passes are granted each calendar month/quarter/year and must be used within that month/quarter/year.
            </small>
            <div class="form-text text-danger">{{ errors.lapsed_customer_guest_pass_frequency }}</div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="num_all_customer_guest_passes">Number of "all customers" guest passes</label>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-5">
            <input type="number"
                   id="num_all_customer_guest_passes"
                   name="num_all_customer_guest_passes"
                   min="0" max="100" step="1"
                   class="form-control"
                   [(ngModel)]="membership.num_all_customer_guest_passes"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <small class="form-text text-muted">
          These guest passes may be used by any customer.
        </small>
        <div class="form-text text-danger">{{ errors.num_all_customer_guest_passes }}</div>
      </div>

      <div class="form-group row" *ngIf="membership.num_all_customer_guest_passes > 0">
        <div class="col-lg-6 col-md-8">
          <div class="indented-subsection">
            <label for="all_customer_guest_pass_frequency">"All customers" guest pass frequency</label>
            <select id="all_customer_guest_pass_frequency" name="all_customer_guest_pass_frequency"
                    class="custom-select"
                    [(ngModel)]="membership.all_customer_guest_pass_frequency"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="MembershipInterval.daily">Daily</option>
              <option [ngValue]="MembershipInterval.weekly">Weekly</option>
              <option [ngValue]="MembershipInterval.monthly">Monthly</option>
              <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
              <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
              <option [ngValue]="MembershipInterval.yearly">Yearly</option>
            </select>
            <small class="form-text text-muted">
              Guest passes are granted each calendar month/quarter/year and must be used within that month/quarter/year.
            </small>
            <div class="form-text text-danger">{{ errors.all_customer_guest_pass_frequency }}</div>
          </div>
        </div>
      </div>

      <div class="alert alert-info">
        Changes to the guest pass policy will be applied to all existing members. The changes may require up to an hour to take effect.
      </div>

      <div class="row">
        <div class="form-group col-lg-6 col-md-8">
          <label for="voucherType">Booking Voucher Type</label>
          <select id="voucherType" name="voucherType"
                  class="custom-select"
                  [(ngModel)]="voucherType"
                  (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
            <option [ngValue]="VoucherType.none">None</option>
            <option [ngValue]="VoucherType.eventType">Event Type</option>
            <option [ngValue]="VoucherType.eventCategory">Event Category</option>
          </select>
        </div>
      </div>

      <div class="indented-subsection" *ngIf="voucherType !== VoucherType.none">
        <div class="row" *ngIf="voucherType === VoucherType.eventType">
          <div class="form-group col-lg-6 col-md-8">
            <label for="voucherTypeSelect">Voucher Event Type</label>
            <select id="voucherTypeSelectLoading" class="custom-select" name="voucher_type"
                    *ngIf="loadingEventTypes" disabled>
              <option>Loading...</option>
            </select>
            <select id="voucherTypeSelect" class="custom-select" name="voucher_type"
                    *ngIf="!loadingEventTypes"
                    [(ngModel)]="membership.voucher_type_id"
                    (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
              <option [ngValue]="null" disabled>---</option>
              <option *ngIf="membership.voucher_type_id && !eventTypeIdInList(membership.voucher_type_id)"
                      [ngValue]="membership.voucher_type_id">
                {{ membership.voucher_type_name }}
                <ng-container *ngIf="membership.voucher_type_status === EventTypeStatus.draft">(draft)</ng-container>
                <ng-container *ngIf="membership.voucher_type_status === EventTypeStatus.retired">(retired)</ng-container>
              </option>
              <option *ngFor="let eventType of eventTypes"
                      [ngValue]="eventType.id">
                {{ eventType.name }}
              </option>
            </select>
            <small class="form-text text-muted">
              Only active event types may be selected for booking vouchers.
            </small>
            <div class="form-text text-danger">{{ errors.voucher_type_id }}</div>
          </div>
        </div>

        <div class="row" *ngIf="voucherType === VoucherType.eventCategory">
          <div class="form-group col-lg-6 col-md-8">
            <label for="voucher_category_id">Voucher Event Category</label>
            <select id="voucherCategorySelectLoading" class="custom-select" name="voucher_category_id"
                    *ngIf="loadingEventCategories" disabled>
              <option>Loading...</option>
            </select>
            <select id="voucher_category_id" class="custom-select" name="voucher_category_id"
                    *ngIf="!loadingEventCategories"
                    [(ngModel)]="membership.voucher_category_id"
                    (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
              <option [ngValue]="null" disabled>---</option>
              <option *ngFor="let eventCategory of eventCategories"
                      [ngValue]="eventCategory.id">
                {{ eventCategory.name }}
              </option>
            </select>
            <div class="form-text text-danger">{{ errors.voucher_category_id }}</div>
          </div>
        </div>

        <div class="form-group">
          <label for="numVouchersInput">
            Number of vouchers per {{ getMembershipIntervalDisplaySingle(membership.interval) }}
          </label>
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-5">
              <input id="numVouchersInput" type="number" name="num_vouchers"
                     min="1" max="100" step="1"
                     class="form-control"
                     [(ngModel)]="membership.num_vouchers"
                     (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
            </div>
          </div>
          <small class="form-text text-muted">
            Vouchers will expire if not used by the end of the {{ getMembershipIntervalDisplaySingle(membership.interval) }}.
          </small>
          <div class="form-text text-danger">{{ errors.num_vouchers }}</div>
        </div>
      </div>

      <div class="alert alert-warning" *ngIf="unsavedVoucherChanges">
        Vouchers are applied when a membership is purchased, or a recurring membership is billed. Changes to the voucher policy will not affect existing members unless they are recurring, in which case vouchers will be granted at the next bill date.
      </div>

      <h3 class="mt-2" id="pricing">Pricing</h3>

      <app-membership-pricing-section
        [membership]="membership"
        [errors]="errors"
        [taxRates]="taxRates"
        [loadingTaxRates]="loadingTaxRates"
        [locations]="getLocations()"
        [(hasPerLocationTaxRates)]="hasPerLocationTaxRates"
        [(hasPerLocationInitiationFeeTaxRates)]="hasPerLocationInitiationFeeTaxRates"
        (changed)="unsavedChanges = true"
        (refreshTaxRates)="loadTaxRates()">
      </app-membership-pricing-section>

      <h3 class="mt-2" id="policies">Policies</h3>

      <h6 class="mt-2"><b>Freeze Policies</b></h6>

      <div class="form-group row">
        <div class="col-lg-6 col-md-8">
          <label for="allowFreezingSelect">Can customers freeze this membership?</label>
          <select id="allowFreezingSelect" name="allow_freezing"
                  class="custom-select"
                  [(ngModel)]="membership.allow_freezing"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="true">Yes</option>
            <option [ngValue]="false">No</option>
          </select>
          <small class="form-text text-muted">
            If this is set to "No", then this membership may only be frozen by staff.
          </small>
          <div class="form-text text-danger">{{ errors.allow_freezing }}</div>
        </div>
      </div>

      <ng-container *ngIf="membership.allow_freezing">
        <div class="form-group">
          <label for="freezeWaitPeriodMonthsInput">
            Minimum amount of time before a customer may freeze this membership (optional)
          </label>
          <div class="row">
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="freezeWaitPeriodMonthsInput" type="number"
                       name="freeze_wait_period_months"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.freeze_wait_period_months"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">months</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.freeze_wait_period_months }}</div>
            </div>
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="freezeWaitPeriodWeeksInput" type="number"
                       name="freeze_wait_period_weeks"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.freeze_wait_period_weeks"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">weeks</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.freeze_wait_period_weeks }}</div>
            </div>
          </div>
          <small class="form-text text-muted">
            Customers will not be allowed to freeze their memberships until this amount of time has passed from purchase. Leave both fields blank in order to allow customers to freeze their membership at any time.
          </small>
        </div>

        <div class="form-group">
          <label for="freezeNoticePeriodMonthsInput">
            Minimum advance notice before a customer may freeze this membership (optional)
          </label>
          <div class="row">
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="freezeNoticePeriodMonthsInput" type="number"
                       name="freeze_notice_period_months"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.freeze_notice_period_months"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">months</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.freeze_notice_period_months }}</div>
            </div>
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="freezeNoticePeriodDaysInput" type="number"
                       name="freeze_notice_period_days"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.freeze_notice_period_days"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">days</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.freeze_notice_period_days }}</div>
            </div>
          </div>
          <small class="form-text text-muted">
            When freezing their memberships, customers will only be able to select billing dates which are at least this amount of time in the future. Leave both fields blank in order to allow customers to choose any billing date when freezing their membership.
          </small>
        </div>

        <div class="form-group">
          <label for="minimumFreezeTimeMonthsInput">
            Minimum amount of time membership must be frozen (optional)
          </label>
          <div class="row">
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="minimumFreezeTimeMonthsInput" type="number"
                       name="minimum_freeze_time_months"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.minimum_freeze_time_months"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">months</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.minimum_freeze_time_months }}</div>
            </div>
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="minimumFreezeTimeWeeksInput" type="number"
                       name="minimum_freeze_time_weeks"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.minimum_freeze_time_weeks"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">weeks</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.minimum_freeze_time_weeks }}</div>
            </div>
          </div>
          <small class="form-text text-muted">
            Customers will not be allowed to unfreeze their memberships until they have been frozen for this amount of time. Leave both fields blank in order to allow customers to unfreeze their membership at any time.
          </small>
        </div>
      </ng-container>

      <div class="form-group">
        <label for="maximumFreezeTimeMonthsInput">
          Maximum amount of time membership may be frozen (optional)
        </label>
        <div class="row">
          <div class="col-lg-4 col-md-5 col-6">
            <div class="input-group">
              <input id="maximumFreezeTimeMonthsInput" type="number"
                     name="maximum_freeze_time_months"
                     min="1" step="1"
                     class="form-control"
                     [(ngModel)]="membership.maximum_freeze_time_months"
                     (ngModelChange)="unsavedChanges = true">
              <div class="input-group-append">
                <div class="input-group-text">months</div>
              </div>
            </div>
            <div class="form-text text-danger">{{ errors.maximum_freeze_time_months }}</div>
          </div>
          <div class="col-lg-4 col-md-5 col-6">
            <div class="input-group">
              <input id="maximumFreezeTimeWeeksInput" type="number"
                     name="maximum_freeze_time_weeks"
                     min="1" step="1"
                     class="form-control"
                     [(ngModel)]="membership.maximum_freeze_time_weeks"
                     (ngModelChange)="unsavedChanges = true">
              <div class="input-group-append">
                <div class="input-group-text">weeks</div>
              </div>
            </div>
            <div class="form-text text-danger">{{ errors.maximum_freeze_time_weeks }}</div>
          </div>
        </div>
        <small class="form-text text-muted">
          If the membership is left frozen for this amount of time, it will be automatically reverted to Active. Leave both fields blank in order to allow memberships to be frozen indefinitely.
        </small>
      </div>

      <div class="form-group indented-subsection" *ngIf="membership.maximum_freeze_time_months || membership.maximum_freeze_time_weeks">
        <label for="cancel_membership_when_maximum_freeze_reached">
          Action when maximum freeze time is reached
        </label>
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <select id="cancel_membership_when_maximum_freeze_reached"
                    name="cancel_membership_when_maximum_freeze_reached"
                    class="custom-select"
                    [(ngModel)]="membership.cancel_membership_when_maximum_freeze_reached"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="false">Reactivate membership</option>
              <option [ngValue]="true">Cancel membership</option>
            </select>
          </div>
        </div>
        <div class="form-text text-danger">{{ errors.cancel_membership_when_maximum_freeze_reached }}</div>
        <small class="form-text text-muted">
          If "Reactivate membership" is selected, then the membership will be charged their normal recurring fee and reactivated when the maximum freeze time is reached.
        </small>
      </div>

      <div class="form-group">
        <label for="freezeFeeInput">Freeze fee</label>
        <div class="row">
          <div class="input-group col-lg-3 col-md-4 col-sm-5">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
            </div>
            <input id="freezeFeeInput" type="number" name="freeze_fee"
                   placeholder="XXX.XX" min="0" step="0.01"
                   class="form-control"
                   [(ngModel)]="membership.freeze_fee"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <div class="form-text text-danger">{{ errors.freeze_fee }}</div>
        <small class="form-text text-muted">
          This amount will be charged each billing cycle for as long as the membership is frozen.
        </small>
      </div>

      <h6 class="mt-2"><b>Cancellation Policies</b></h6>

      <div class="form-group row">
        <div class="col-lg-6 col-md-8">
          <label for="allowCancellationSelect">Can customers cancel this membership?</label>
          <select id="allowCancellationSelect" name="allow_cancellation"
                  class="custom-select"
                  [(ngModel)]="membership.allow_cancellation"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="true">Yes</option>
            <option [ngValue]="false">No</option>
          </select>
          <div class="form-text text-danger">{{ errors.allow_cancellation }}</div>
        </div>
      </div>

      <ng-container *ngIf="membership.allow_cancellation">

        <div class="form-group">
          <label for="cancellationWaitPeriodMonthsInput">
            Minimum amount of time before a customer may cancel this membership (optional)
          </label>
          <div class="row">
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="cancellationWaitPeriodMonthsInput" type="number"
                       name="cancellation_wait_period_months"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.cancellation_wait_period_months"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">months</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.cancellation_wait_period_months }}</div>
            </div>
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="cancellationWaitPeriodWeeksInput" type="number"
                       name="cancellation_wait_period_weeks"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.cancellation_wait_period_weeks"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">weeks</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.cancellation_wait_period_weeks }}</div>
            </div>
          </div>
          <small class="form-text text-muted">
            Customers will not be allowed to cancel their memberships until this amount of time has passed from purchase. Leave both fields blank in order to allow customers to cancel their membership at any time.
          </small>
        </div>

        <div class="form-group">
          <label for="cancellation_notice_period_months">
            Minimum advance notice before a customer may cancel this membership (optional)
          </label>
          <div class="row">
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="cancellation_notice_period_months" type="number"
                       name="cancellation_notice_period_months"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.cancellation_notice_period_months"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">months</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.cancellation_notice_period_months }}</div>
            </div>
            <div class="col-lg-4 col-md-5 col-6">
              <div class="input-group">
                <input id="cancellation_notice_period_days" type="number"
                       name="cancellation_notice_period_days"
                       min="1" step="1"
                       class="form-control"
                       [(ngModel)]="membership.cancellation_notice_period_days"
                       (ngModelChange)="unsavedChanges = true">
                <div class="input-group-append">
                  <div class="input-group-text">days</div>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.cancellation_notice_period_days }}</div>
            </div>
          </div>
          <small class="form-text text-muted">
            When cancelling their memberships, customers will only be able to select billing dates which are at least this amount of time in the future. Leave both fields blank in order to allow customers to choose any billing date when cancelling their membership.
          </small>
        </div>

        <div class="form-group">
          <label>
            Date range in which a customer's cancellation may take effect (optional)
          </label>
          <div class="row">
            <div class="col-lg-4 col-md-5 col-6">
              <label for="cancellationDateRangeStartInput">Start Date</label>
              <app-date-picker [id]="'cancellationDateRangeStartInput'"
                               [(content)]="membership.cancellation_date_range_start"
                               (contentChange)="unsavedChanges = true"></app-date-picker>
              <div class="form-text text-danger">{{ errors.cancellation_date_range_start }}</div>
            </div>
            <div class="col-lg-4 col-md-5 col-6">
              <label for="cancellationDateRangeEndInput">End Date</label>
              <app-date-picker [id]="'cancellationDateRangeEndInput'"
                               [(content)]="membership.cancellation_date_range_end"
                               (contentChange)="unsavedChanges = true"></app-date-picker>
              <div class="form-text text-danger">{{ errors.cancellation_date_range_end }}</div>
            </div>
          </div>
          <small class="form-text text-muted">
            When cancelling their memberships, customers will only be able to select billing dates within this range. Once the end date has passed, customers will not be able to cancel until the range is changed or removed. Leave both fields blank in order to allow customers to choose any billing date when cancelling their membership. Cancellations made by staff are not restricted.
          </small>
        </div>

      </ng-container>

      <h6 class="mt-2"><b>Entry Restrictions</b></h6>

      <div class="form-group"
           *ngIf="getLocations() && (getLocations().length > 1)">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label for="isSingleLocationSelect">
              Is this membership restricted to a single location (customer choice)?
            </label>
            <select id="isSingleLocationSelect" name="is_single_location"
                    class="custom-select"
                    [(ngModel)]="membership.is_single_location"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
        </div>
        <small class="form-text text-muted">
          If this option is enabled, a customer purchasing this membership will need to select the location where the membership can be used. The customer will not be able to use the membership for check-in at any other location. Regardless of a customer's Home Location, revenue for the membership will be attributed to the membership's location.
        </small>
        <div class="form-text text-danger">{{ errors.is_single_location }}</div>
      </div>

      <div class="form-group"
           *ngIf="getLocations() && (getLocations().length > 1)">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label for="isLocationRestrictedSelect">
              Is this membership restricted to a certain location or set of locations (fixed)?
            </label>
            <select id="isLocationRestrictedSelect" name="is_location_restricted"
                    class="custom-select"
                    [(ngModel)]="membership.is_location_restricted"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
        </div>
        <small class="form-text text-muted">
          If this option is enabled, the membership may only be used for check-in at a fixed set of locations. If "Is this membership restricted to a single location (customer choice)?" is also enabled, then the purchaser may only select from the configured set of locations.
        </small>
        <div class="form-text text-danger">{{ errors.is_location_restricted }}</div>
      </div>

      <div class="form-group indented-subsection" *ngIf="membership.is_location_restricted">
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <label>
              Allowed Locations
            </label>
            <ul class="mb-2 pl-3">
              <li *ngFor="let location of membership.allowed_locations; let idx = index;">
                {{ location.name }}
                <a href="#" class="link-danger pl-1"
                   (click)="membership.allowed_locations.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                  Remove
                </a>
              </li>
              <li *ngIf="membership.allowed_locations.length === 0"
                  class="text-muted">
                No locations selected
              </li>
            </ul>
            <a href="#"
               (click)="openAddAllowedLocationModal();$event.preventDefault();">
              Select Location
            </a>
            <div class="form-text text-danger">{{ errors.allowed_locations }}</div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-lg-6 col-md-8">
          <label for="hasLimitedEntrySelect">
            Is this membership limited to entry at certain days/times?
          </label>
          <select id="hasLimitedEntrySelect" name="has_limited_entry"
                  class="custom-select"
                  [(ngModel)]="membership.has_limited_entry"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="true">Yes</option>
            <option [ngValue]="false">No</option>
          </select>
          <div class="form-text text-danger">{{ errors.has_limited_entry }}</div>
        </div>
      </div>

      <div class="form-group indented-subsection" *ngIf="membership.has_limited_entry">
        <p><b>Times when this membership may be used for entry:</b></p>

        <ng-container *ngFor="let timeSlot of entryTimeSlots">
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label>Start Time *</label>
                <input type="time" step="60"
                       class="form-control"
                       [name]="'startTime' + timeSlot.id.toString()"
                       [(ngModel)]="timeSlot.start_time"
                       (ngModelChange)="unsavedChanges = true">
                <div class="form-text text-danger"
                     *ngIf="entryTimeSlotErrors[timeSlot.id]">
                  {{ entryTimeSlotErrors[timeSlot.id].start_time }}
                </div>
              </div>
              <div class="col-4">
                <label>End Time *</label>
                <input type="time" step="60"
                       class="form-control"
                       [name]="'endTime' + timeSlot.id.toString()"
                       [(ngModel)]="timeSlot.end_time"
                       (ngModelChange)="unsavedChanges = true">
                <div class="form-text text-danger"
                     *ngIf="entryTimeSlotErrors[timeSlot.id]">
                  {{ entryTimeSlotErrors[timeSlot.id].end_time }}
                </div>
              </div>
              <div class="col-4">
                <button class="btn btn-danger btn-sm float-right"
                        (click)="removeEntryTimeSlot(timeSlot); unsavedChanges = true;">
                  Remove Time Slot
                </button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Days Available *</label>
            <br>
            <button class="btn mr-2 day-button" type="button"
                    [class.btn-outline-secondary]="!timeSlot.is_available_sunday"
                    [class.btn-primary]="timeSlot.is_available_sunday"
                    (click)="timeSlot.is_available_sunday = !timeSlot.is_available_sunday; unsavedChanges = true;">
              S
            </button>
            <button class="btn mr-2 day-button" type="button"
                    [class.btn-outline-secondary]="!timeSlot.is_available_monday"
                    [class.btn-primary]="timeSlot.is_available_monday"
                    (click)="timeSlot.is_available_monday = !timeSlot.is_available_monday; unsavedChanges = true;">
              M
            </button>
            <button class="btn mr-2 day-button" type="button"
                    [class.btn-outline-secondary]="!timeSlot.is_available_tuesday"
                    [class.btn-primary]="timeSlot.is_available_tuesday"
                    (click)="timeSlot.is_available_tuesday = !timeSlot.is_available_tuesday; unsavedChanges = true;">
              T
            </button>
            <button class="btn mr-2 day-button" type="button"
                    [class.btn-outline-secondary]="!timeSlot.is_available_wednesday"
                    [class.btn-primary]="timeSlot.is_available_wednesday"
                    (click)="timeSlot.is_available_wednesday = !timeSlot.is_available_wednesday; unsavedChanges = true;">
              W
            </button>
            <button class="btn mr-2 day-button" type="button"
                    [class.btn-outline-secondary]="!timeSlot.is_available_thursday"
                    [class.btn-primary]="timeSlot.is_available_thursday"
                    (click)="timeSlot.is_available_thursday = !timeSlot.is_available_thursday; unsavedChanges = true;">
              T
            </button>
            <button class="btn mr-2 day-button" type="button"
                    [class.btn-outline-secondary]="!timeSlot.is_available_friday"
                    [class.btn-primary]="timeSlot.is_available_friday"
                    (click)="timeSlot.is_available_friday = !timeSlot.is_available_friday; unsavedChanges = true;">
              F
            </button>
            <button class="btn mr-2 day-button" type="button"
                    [class.btn-outline-secondary]="!timeSlot.is_available_saturday"
                    [class.btn-primary]="timeSlot.is_available_saturday"
                    (click)="timeSlot.is_available_saturday = !timeSlot.is_available_saturday; unsavedChanges = true;">
              S
            </button>
            <br>
            <button class="btn btn-link btn-sm pl-0" type="button"
                    *ngIf="!allDaysAreAvailable(timeSlot)"
                    (click)="setAllDaysAvailability(timeSlot, true); unsavedChanges = true;">
              Select All
            </button>
            <button class="btn btn-link btn-sm pl-0" type="button"
                    *ngIf="allDaysAreAvailable(timeSlot)"
                    (click)="setAllDaysAvailability(timeSlot, false); unsavedChanges = true;">
              Deselect All
            </button>
          </div>

          <div class="alert alert-danger" role="alert"
               *ngIf="entryTimeSlotErrors[timeSlot.id] && entryTimeSlotErrors[timeSlot.id].non_field_errors">
            {{ entryTimeSlotErrors[timeSlot.id].non_field_errors }}
          </div>

          <hr>
        </ng-container>

        <button class="btn btn-sm btn-link pl-0 mb-3" type="button"
                (click)="addNewEntryTimeSlot(); unsavedChanges = true;">
          + Add New Time Period
        </button>
      </div>

      <h3 class="mt-2" id="climber-app-text">Climber App Text</h3>

      <div class="form-group row">
        <div class="col-lg-10">
          <label>Terms and Conditions Checkbox Text</label>
          <app-markdown-editor [id]="'tsAndCsCheckboxText'"
                               [(content)]="membership.terms_and_conditions_checkbox_text"
                               (contentChange)="unsavedChanges = true"
                               [shortEditor]="true"></app-markdown-editor>
          <small class="form-text text-muted">
            This text will be shown alongside a checkbox which must be checked by the customer before purchasing this roster membership. If this is left blank, no checkbox will be shown and it will not be required.
          </small>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-lg-10">
          <label>Membership Confirmation Text</label>
          <app-markdown-editor [id]="'confirmationTextArea'"
                               [(content)]="membership.confirmation_text"
                               (contentChange)="unsavedChanges = true"
                               [shortEditor]="true"></app-markdown-editor>
          <small class="form-text text-muted">
            This will be shown to customers on the confirmation screen after they purchase this roster membership online.
          </small>
          <div class="form-text text-danger">{{ errors.confirmation_text }}</div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-lg-10">
          <label>Payment Information Text</label>
          <app-markdown-editor [id]="'paymentInfoTextArea'"
                               [(content)]="membership.payment_information_text"
                               (contentChange)="unsavedChanges = true"
                               [shortEditor]="true"></app-markdown-editor>
          <small class="form-text text-muted">
            This will be shown to customers on their receipt after they purchase this roster membership online.
          </small>
          <div class="form-text text-danger">{{ errors.payment_information_text }}</div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-lg-10">
          <label>Recurring Payment Confirmation Text</label>
          <app-markdown-editor [id]="'recurringPaymentConfirmationTextArea'"
                               [(content)]="membership.recurring_payment_confirmation_text"
                               (contentChange)="unsavedChanges = true"
                               [shortEditor]="true"></app-markdown-editor>
          <small class="form-text text-muted">
            This will be included in the confirmation email sent to membership owners when recurring payments are charged. This is <b>not</b> included in the confirmation email sent when the membership is initially purchased.
          </small>
          <div class="form-text text-danger">{{ errors.recurring_payment_confirmation_text }}</div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-lg-10">
          <label>Failed Payment Notification Text</label>
          <app-markdown-editor [id]="'failedPaymentNotificationTextArea'"
                               [(content)]="membership.failed_payment_notification_text"
                               (contentChange)="unsavedChanges = true"
                               [shortEditor]="true"></app-markdown-editor>
          <small class="form-text text-muted">
            This will be included in the notification email sent to membership owners when recurring payments fail.
          </small>
          <div class="form-text text-danger">{{ errors.failed_payment_notification_text }}</div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-lg-10">
          <label for="membership_management_info_alert_text">
            Membership Management Info Text
          </label>
          <app-markdown-editor [id]="'membership_management_info_alert_text'"
                               [(content)]="membership.membership_management_info_alert_text"
                               (contentChange)="unsavedChanges = true"
                               [shortEditor]="true"></app-markdown-editor>
          <small class="form-text text-muted">
            Add any additional information you want displayed on the Membership Management page in the Climber App here. This text will be displayed in a blue info box at the bottom of the page.
            <br>
            This can be used for information such as who to contact if a customer has additional questions, terms & conditions, etc.
          </small>
          <div class="form-text text-danger">{{ errors.membership_management_info_alert_text }}</div>
        </div>
      </div>

      <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
        <h3 class="mt-2" id="mailchimp">Mailchimp Tags and Events</h3>

        <p class="text-muted">
          To learn more, see our
          <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
             target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
        </p>

        <p class="mb-1">
          The following tags and events are synced to Mailchimp automatically for all memberships of this type:
        </p>
        <div class="rounded-table-wrapper rounded-table-tight mb-3 mailchimp-auto-events-table">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Synced To</th>
                <th>When</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Active Member</td>
                <td>Tag</td>
                <td>Members</td>
                <td>While the membership is active</td>
              </tr>
              <tr>
                <td>Frozen Member</td>
                <td>Tag</td>
                <td>Members</td>
                <td>While the membership is frozen</td>
              </tr>
              <tr>
                <td><code>membership_purchased_by_cust</code></td>
                <td>Event</td>
                <td>Owner</td>
                <td>When the membership is purchased</td>
              </tr>
              <tr>
                <td><code>membership_purchased_for_cust</code></td>
                <td>Event</td>
                <td>Member(s)</td>
                <td>When the membership is purchased</td>
              </tr>
              <tr>
                <td><code>membership_scheduled_to_cancel</code></td>
                <td>Event</td>
                <td>Owner</td>
                <td>When the membership is scheduled to cancel</td>
              </tr>
              <tr>
                <td><code>membership_cancelled</code></td>
                <td>Event</td>
                <td>Owner</td>
                <td>When the membership is cancelled</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="form-group">
          <label for="mailchimpPurchasedByCustomerEventNameInput">
            "Membership Purchased By Customer" Event Name
          </label>
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <input id="mailchimpPurchasedByCustomerEventNameInput"
                     type="text" name="mailchimp_purchased_by_customer_event_name"
                     maxlength="30"
                     class="form-control"
                     [(ngModel)]="membership.mailchimp_purchased_by_customer_event_name"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this event will be created in Mailchimp for the membership owner whenever a membership of this type is purchased.
            <br>
            Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
          </small>
          <div class="form-text text-danger">{{ errors.mailchimp_purchased_by_customer_event_name }}</div>
        </div>

        <div class="form-group">
          <label for="mailchimpPurchasedForCustomerEventNameInput">
            "Membership Purchased For Customer" Event Name
          </label>
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <input id="mailchimpPurchasedForCustomerEventNameInput"
                     type="text" name="mailchimp_purchased_for_customer_event_name"
                     maxlength="30"
                     class="form-control"
                     [(ngModel)]="membership.mailchimp_purchased_for_customer_event_name"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this event will be created in Mailchimp for each member whenever a membership of this type is purchased.
            <br>
            Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
          </small>
          <div class="form-text text-danger">{{ errors.mailchimp_purchased_for_customer_event_name }}</div>
        </div>

        <div class="form-group">
          <label for="mailchimpActiveMemberTagNameInput">
            "Active Member" Tag Name
          </label>
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <input id="mailchimpActiveMemberTagNameInput"
                     type="text" name="mailchimp_active_member_tag_name"
                     maxlength="64"
                     class="form-control"
                     [(ngModel)]="membership.mailchimp_active_member_tag_name"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this tag will be assigned in Mailchimp to all members of active memberships of this type.
            <br>
            It may take up to 15 minutes to update all existing members when this field is changed.
          </small>
          <div class="form-text text-danger">{{ errors.mailchimp_active_member_tag_name }}</div>
        </div>

        <div class="form-group">
          <label for="mailchimpActiveMembershipOwnerTagNameInput">
            "Active Membership Owner" Tag Name
          </label>
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <input id="mailchimpActiveMembershipOwnerTagNameInput"
                     type="text" name="mailchimp_active_membership_owner_tag_name"
                     maxlength="64"
                     class="form-control"
                     [(ngModel)]="membership.mailchimp_active_membership_owner_tag_name"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this tag will be assigned in Mailchimp to all owners of active memberships of this type.
            <br>
            It may take up to 15 minutes to update all existing owners when this field is changed.
          </small>
          <div class="form-text text-danger">{{ errors.mailchimp_active_membership_owner_tag_name }}</div>
        </div>

        <div class="form-group">
          <label for="mailchimpMembershipCancelledEventNameInput">
            "Membership Cancelled" Event Name
          </label>
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <input id="mailchimpMembershipCancelledEventNameInput"
                     type="text" name="mailchimp_cancelled_event_name"
                     maxlength="30"
                     class="form-control"
                     [(ngModel)]="membership.mailchimp_cancelled_event_name"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this event will be created in Mailchimp for the membership owner whenever a membership of this type is cancelled.
            <br>
            Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
          </small>
          <div class="form-text text-danger">{{ errors.mailchimp_cancelled_event_name }}</div>
        </div>

        <div class="form-group">
          <label for="mailchimpMembershipScheduledToCancelEventNameInput">"Membership Scheduled to Cancel" Event Name</label>
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <input id="mailchimpMembershipScheduledToCancelEventNameInput"
                     type="text" name="mailchimp_scheduled_to_cancel_event_name"
                     maxlength="30"
                     class="form-control"
                     [(ngModel)]="membership.mailchimp_scheduled_to_cancel_event_name"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this event will be created in Mailchimp for the membership owner whenever a membership of this type is scheduled to cancel.
            <br>
            Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
          </small>
          <div class="form-text text-danger">{{ errors.mailchimp_scheduled_to_cancel_event_name }}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.square">
        <h3 class="mt-2" id="square">Square Customer Groups</h3>

        <div class="alert alert-info">
          In order for a Square customer group to be available for configuration, it must first be enabled as "managed by Capitan" by navigating to
          <a routerLink="/organization-settings" target="_blank">Organization Settings</a>
          and selecting "Manage Customer Groups" in the Integrations section.
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-lg-8 col-md-10">
              <label for="memberSquareCustomerGroupSelect">
                "Active Member" Customer Group
              </label>
              <div class="float-right mb-1">
                <a href="#"
                   (click)="$event.preventDefault();resyncSquareCustomerGroups();">
                  Resync Customer Groups
                </a>
              </div>
              <select id="memberSquareCustomerGroupSelectLoading"
                      class="custom-select" name="member_square_customer_group_id"
                      *ngIf="loadingSquareCustomerGroups" disabled>
                <option>Loading...</option>
              </select>
              <select id="memberSquareCustomerGroupSelect"
                      class="custom-select" name="member_square_customer_group_id"
                      *ngIf="!loadingSquareCustomerGroups"
                      [(ngModel)]="membership.member_square_customer_group_id"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="null">None</option>
                <option *ngFor="let squareCustomerGroup of squareCustomerGroups"
                        [ngValue]="squareCustomerGroup.id">
                  {{ squareCustomerGroup.name }}
                </option>
              </select>
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this customer group will be assigned in Square to all members of active memberships of this type.
            <br>
            It may take up to 15 minutes to update all existing members when this field is changed.
          </small>
          <div class="form-text text-danger">{{ errors.member_square_customer_group_id }}</div>
        </div>

      </ng-container>

      <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.lightspeed">
        <h3 class="mt-2" id="lightspeed">Lightspeed Customer Groups</h3>

        <div class="alert alert-info">
          In order for a Lightspeed customer group to be available for configuration, it must first be enabled as "managed by Capitan" by navigating to
          <a routerLink="/organization-settings" target="_blank">Organization Settings</a>
          and selecting "Manage Customer Groups" in the Integrations section.
        </div>

        <div class="alert alert-info">
          Lightspeed only allows a customer to be assigned to a single group. When a customer qualifies for multiple groups, Capitan will assign the customer to the group with the highest ranking. The group rankings may be updated in
          <a routerLink="/organization-settings">Organization Settings</a>.
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-lg-8 col-md-10">
              <label for="memberLightspeedCustomerGroupSelect">
                "Active Member" Customer Group
              </label>
              <div class="float-right mb-1">
                <a href="#"
                   (click)="$event.preventDefault();resyncLightspeedCustomerGroups();">
                  Resync Customer Groups
                </a>
              </div>
              <select id="memberLightspeedCustomerGroupSelectLoading"
                      class="custom-select" name="member_lightspeed_customer_group_id"
                      *ngIf="loadingLightspeedCustomerGroups" disabled>
                <option>Loading...</option>
              </select>
              <select id="memberLightspeedCustomerGroupSelect"
                      class="custom-select" name="member_lightspeed_customer_group_id"
                      *ngIf="!loadingLightspeedCustomerGroups"
                      [(ngModel)]="membership.member_lightspeed_customer_group_id"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="null">None</option>
                <option *ngFor="let lightspeedCustomerGroup of lightspeedCustomerGroups"
                        [ngValue]="lightspeedCustomerGroup.id">
                  {{ lightspeedCustomerGroup.name }}
                </option>
              </select>
            </div>
          </div>
          <small class="form-text text-muted">
            If provided, this customer group will be assigned in Lightspeed to all members of active memberships of this type.
            <br>
            It may take up to 15 minutes to update all existing members when this field is changed.
          </small>
          <div class="form-text text-danger">{{ errors.member_lightspeed_customer_group_id }}</div>
        </div>

      </ng-container>

      <div class="alert alert-info" role="alert" *ngIf="loadingSave">
        Loading...
      </div>

      <div class="float-right">
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="loadingSave" [class.disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_STAY_HERE">
          Save
        </button>
        <button type="submit" class="btn btn-primary"
                [disabled]="loadingSave" [class.disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_CONTINUE">
          Save and Continue
        </button>
      </div>
      <button [routerLink]="['/events/setup/event-types']"
              [queryParams]="{status: eventType?.status}"
              class="btn btn-secondary"
              [disabled]="loadingSave" [class.disabled]="loadingSave">
        Back
      </button>

    </form>

  </div>
</div>
